import { publicPath } from '../vue.config'

import Home from "./pages/Home.vue";
import Login from './pages/Login.vue'

import Index from './pages/Index.vue'
//import CarPosition from './pages/CarPosition.vue'
import DataCenter from './pages/DataCenter.vue'
import FinancialAnalysis from './pages/FinancialAnalysis.vue'

import ContractOrder from './pages/orderManage/contract/table.vue'
import ContractOrderOwn from './pages/orderManage/contract/own/table.vue'
import ContractOrderOwnTobe from './pages/orderManage/contract/own/tobe/table.vue'
import ContractOrderOwnIng from './pages/orderManage/contract/own/ing/table.vue'
import ContractOrderOwnArrive from './pages/orderManage/contract/own/arrive/table.vue'
import ContractOrderOwnUncheck from './pages/orderManage/contract/own/uncheck/table.vue'
import ContractOrderOwnDone from './pages/orderManage/contract/own/done/table.vue'
import ContractOrderHire from './pages/orderManage/contract/hire/table.vue'
// import OrderContractDetail from './pages/orderManage/contract/detail.vue'
import OrderContractView from './pages/orderManage/contract/view.vue'
import OrderContractView1 from './pages/orderManage/contract/view1.vue'
import OrderContractView2 from './pages/orderManage/contract/view2.vue'
import OrderContractView21 from './pages/orderManage/contract/view21.vue'
import OrderContractView3 from './pages/orderManage/contract/view3.vue'
import OrderContractView4 from './pages/orderManage/contract/view4.vue'
import OrderContractView41 from './pages/orderManage/contract/view41.vue'
import OrderContractView5 from './pages/orderManage/contract/view5.vue'

import NonContractOrder from './pages/orderManage/nonContractOrder/table.vue'
import NonContractOrderOwn from './pages/orderManage/nonContractOrder/own/table.vue'
import NonContractOrderOwnTobe from './pages/orderManage/nonContractOrder/own/tobe/table.vue'
import NonContractOrderOwnIng from './pages/orderManage/nonContractOrder/own/ing/table.vue'
import NonContractOrderOwnArrive from './pages/orderManage/nonContractOrder/own/arrive/table.vue'
import NonContractOrderOwnUncheck from './pages/orderManage/nonContractOrder/own/uncheck/table.vue'
import NonContractOrderOwnDone from './pages/orderManage/nonContractOrder/own/done/table.vue'
import NonContractOrderhire from './pages/orderManage/nonContractOrder/hire/table.vue'
import NonContractOrderDetail from './pages/orderManage/nonContractOrder/detail.vue'
import NonContractOrderDetailDone from './pages/orderManage/nonContractOrder/detailDone.vue'
import OrderNoContractAdd from './pages/orderManage/nonContractOrder/add.vue'
import OrderNoContractView from './pages/orderManage/nonContractOrder/view.vue'
import OrderNoContractView1 from './pages/orderManage/nonContractOrder/view1.vue'
import OrderNoContractView2 from './pages/orderManage/nonContractOrder/view2.vue'
import OrderNoContractView3 from './pages/orderManage/nonContractOrder/view3.vue'
import OrderNoContractView21 from './pages/orderManage/nonContractOrder/view21.vue'
import OrderNoContractView4 from './pages/orderManage/nonContractOrder/view4.vue'
import OrderNoContractView41 from './pages/orderManage/nonContractOrder/view41.vue'
import OrderNoContractView5 from './pages/orderManage/nonContractOrder/view5.vue'
import OrderNoContractFee from './pages/orderManage/nonContractOrder/fee.vue'
// 订单补差
import MakeupList from './pages/orderManage/makeup/table.vue'
import Makeupdetail from './pages/orderManage/makeup/detail.vue'
import Makeupedit from './pages/orderManage/makeup/edit.vue'
// 订单回收站
import recycle from './pages/orderManage/recycle/table.vue'

import ContractList from './pages/contract/manage/table.vue'
import ContractTobeList from './pages/contract/manage/tobe/table.vue'
import ContractIngList from './pages/contract/manage/ing/table.vue'
import ContractUncheckList from './pages/contract/manage/uncheck/table.vue'
import ContractDoneList from './pages/contract/manage/done/table.vue'
import ContractDetail from './pages/contract/manage/detail.vue'

import ContractOrderList from './pages/contract/manage/orderList/table.vue'
import ContractOrderOwnList from './pages/contract/manage/orderList/own/table.vue'
import ContractOrderOwnTobeList from './pages/contract/manage/orderList/own/tobe/table.vue'
import ContractOrderOwnIngList from './pages/contract/manage/orderList/own/ing/table.vue'
import ContractOrderOwnArriveList from './pages/contract/manage/orderList/own/arrive/table.vue'
import ContractOrderOwnUnckeckList from './pages/contract/manage/orderList/own/uncheck/table.vue'
import ContractOrderOwnDoneList from './pages/contract/manage/orderList/own/done/table.vue'
import ContractOrderHireList from './pages/contract/manage/orderList/hire/table.vue'
import ContractOrderAllList from './pages/contract/manage/orderList/all/table.vue'
import ContractOrderView from './pages/contract/manage/orderList/orderView.vue'
import ContractOrderDetail from './pages/contract/manage/orderList/orderDetail.vue'
import ContractOrderDetail2 from './pages/contract/manage/orderList/orderDetail2.vue'

import ContractMakeup from './pages/contract/makeup/table.vue'
import ContractMakeupDetail from './pages/contract/makeup/detail.vue'
import ContractMakeupEdit from './pages/contract/makeup/edit.vue'

import CustomerList from './pages/customer/manage/list.vue'
import CustomerDetail from './pages/customer/manage/detail.vue'
import CustomerEdit from './pages/customer/manage/edit.vue'
import CustomerView from './pages/customer/manage/view.vue'
import CustomerCarrier from './pages/customer/carrier/table.vue'
import CustomerCarrierDetail from './pages/customer/carrier/detail.vue'
import CustomerLog from './pages/customer/log/table.vue'
import CustomerLogList from './pages/customer/log/list.vue'

// 车辆管理
import Vehicle from './pages/vehicle/manage/table.vue'
import VehicleTeam from './pages/vehicle/manage/team.vue'
import VehicleList from './pages/vehicle/manage/list.vue'
import VehicleDetail from './pages/vehicle/manage/detail.vue'
import VehicleView from './pages/vehicle/manage/view.vue'
import VehicleViewTrip from './pages/vehicle/manage/viewTrip.vue'

import Vehicledocument from './pages/vehicle/manage/document.vue'
import Vehicleinsurance from './pages/vehicle/manage/insurance.vue'
import VehicleViewUrl from './pages/vehicle/manage/viewUrl.vue'

// 车辆维护
import VehicleMaintain from './pages/vehicle/maintain/table.vue'
import VehicleMaintainDetail from './pages/vehicle/maintain/detail.vue'

import VehicleGroup from './pages/vehicle/group/table.vue'
import VehicleGroupList from './pages/vehicle/groupList/table.vue'
import VehicleGroupTable from './pages/vehicle/groupList/list.vue'

import VehicleExpatriate from './pages/vehicle/expatriate/table.vue'
import VehicleExpatriateDetail from './pages/vehicle/expatriate/detail.vue'
import VehicleExpatriateView from './pages/vehicle/expatriate/view.vue'

import VehicleHang from './pages/vehicle/hang/table.vue'
import VehicleHangTab from './pages/vehicle/hang/tabpage.vue'
import VehicleHangDetail from './pages/vehicle/hang/detail.vue'
import VehicleHangView from './pages/vehicle/hang/view.vue'

// 车辆证件
import VehicleDocuments from './pages/vehicle/documents/tabpage.vue'
import VehicleDocumentsList from './pages/vehicle/documents/table.vue'
import VehicleInsuranceList from './pages/vehicle/documents/insuranceTable.vue'

import VehicleInvestDanger from './pages/vehicle/investDanger/tabpage.vue'
import VehicleInvestDangerList from './pages/vehicle/investDanger/list.vue'
import VehicleInvestDangerMonthList from './pages/vehicle/investDanger/monthList.vue'
import VehicleInvestDangerPDF from './pages/vehicle/investDanger/pdf'

// 违章管理
import BreakRules from './pages/vehicle/breakRules/table.vue'
import BreakRulesList from './pages/vehicle/breakRules/list.vue'
import BreakRulesDetailList from './pages/vehicle/breakRules/detailList.vue'

// 维保管理
import FixList from './pages/fix/manage/table.vue'
import FixdDtail from './pages/fix/manage/detail.vue'

import FixRepairerList from './pages/fix/repairManage/table.vue'
import FixRepairerDetail from './pages/fix/repairManage/detail.vue'

import FixRepairer from './pages/fix/repairer/table.vue'
import FixPayment from './pages/fix/repairer/paymentHistory.vue'

import FixConfigTable from './pages/fix/config/table.vue'
// 维修订单回收站
import FixRecycleTable from './pages/fix/recycle/table.vue'

// 人员管理
// 经理管理
import StaffManager from './pages/staff/manager/tabpage.vue'
import StaffManagerTable from './pages/staff/manager/table.vue'
import StaffManagerDetail from './pages/staff/manager/detail.vue'

import StaffMainAccountant from './pages/staff/mainAccountant/tabpage.vue'
import StaffMainAccountantTable from './pages/staff/mainAccountant/table.vue'
import MainAccountantDetail from './pages/staff/mainAccountant/detail.vue'

import StaffSpecialAccountant from './pages/staff/specialAccountant/tabpage.vue'
import StaffSpecialAccountantTable from './pages/staff/specialAccountant/table.vue'
import SpecialAccountantDetail from './pages/staff/specialAccountant/detail.vue'

import StaffCashier from './pages/staff/cashier/tabpage.vue'
import StaffCashierTable from './pages/staff/cashier/table.vue'
import CashierDetail from './pages/staff/cashier/detail.vue'

import StaffCaptain from './pages/staff/captain/tabpage.vue'
import StaffCaptainTable from './pages/staff/captain/table.vue'
import StaffCaptainDetail from './pages/staff/captain/detail.vue'


import StaffSalesman from './pages/staff/salesman/tabpage.vue'
import StaffSalesmanTable from './pages/staff/salesman/table.vue'
import StaffSalesmanDetail from './pages/staff/salesman/detail.vue'

import StaffViceCaptain from './pages/staff/viceCaptain/tabpage.vue'
import StaffViceCaptainTable from './pages/staff/viceCaptain/table.vue'
import ViceCaptainDetail from './pages/staff/viceCaptain/detail.vue'

import StaffMaintenance from './pages/staff/maintenance/tabpage.vue'
import StaffMaintenanceTable from './pages/staff/maintenance/table.vue'
import Maintenancedetail from './pages/staff/maintenance/detail.vue'

import StaffVehicleService from './pages/staff/vehicleService/tabpage.vue'
import StaffVehicleServiceTable from './pages/staff/vehicleService/table.vue'
import VehicleServiceDetail from './pages/staff/vehicleService/detail.vue'
// 司机
import StaffDriver from './pages/staff/driver/table.vue'
import StaffDriverTeam from './pages/staff/driver/team.vue'
import StaffDriverList from './pages/staff/driver/list.vue'
import StaffDriverDetail from './pages/staff/driver/detail.vue'
import StaffDriverHy from './pages/staff/driver/hy.vue'
import StaffDriverDocument from './pages/staff/driver/document.vue'
// 押运
import StaffEscort from './pages/staff/escort/table.vue'
import StaffEscortHy from './pages/staff/escort/hy.vue'
import StaffEscortTeam from './pages/staff/escort/team.vue'
import StaffEscortList from './pages/staff/escort/list.vue'
import StaffEscortDetail from './pages/staff/escort/detail.vue'
import StaffVehicleAttendance from './pages/staff/vehicleAttendance/table.vue'
import StaffAttendanceSummary from './pages/staff/attendanceSummary/table.vue'
import StaffDriverAttendance from './pages/staff/driverAttendance/table.vue'
import StaffEscortAttendance from './pages/staff/escortAttendance/table.vue'
import StaffTempDriver from './pages/staff/tempDriver/table.vue'
import TempDriverDetail from './pages/staff/tempDriver/detail.vue'
import StaffTempEscort from './pages/staff/tempEscort/table.vue'
import TempEscortDetail from './pages/staff/tempEscort/detail.vue'

import StaffCont from './pages/staff/cont/table.vue'

import FinanceReimburse from './pages/finance/reimburse/tabpage.vue'
import FinanceReimburseTable from './pages/finance/reimburse/table.vue'
import FinanceReimburseTableChecked from './pages/finance/reimburse/tableChecked.vue'
import FinanceFeightStatistics from './pages/finance/feightStatistics/table.vue'
import FinanceShipper from './pages/finance/shipper/table.vue'
import ViewOrder from './pages/finance/shipper/viewOrder.vue'
import ContractFix from './pages/finance/shipper/contractFix.vue'
import PaymentHistory from './pages/finance/shipper/paymentHistory.vue'
// 预支款
import FinanceInitialPayment from './pages/finance/initialPayment/table.vue'
// 预支款打款记录
import InitialPaymentRecord from './pages/finance/initialPayment/PaymentRecord.vue'
// 预支款打款记录费用详情
import InitialPaymentRecordMoneyDetail from './pages/finance/initialPayment/MoneyDetail.vue'
// 预支款打款记录全部费用详情
import InitialPaymentRecordAllMoneyDetail from './pages/finance/initialPayment/AllMoneyDetail.vue'
// 预支款全部打款记录
import InitialAllPaymentRecord from './pages/finance/initialPayment/AllPaymentRecord.vue'
import FinanceCarrier from './pages/finance/carrier/table.vue'
import CarrierOrder from './pages/finance/carrier/carrierOrder.vue'
import CarrierPaymentHistory from './pages/finance/carrier/paymentHistory.vue'
import FinanceReceivableAccounts from './pages/finance/receivableAccounts/table.vue'
import AccountStatistics from './pages/finance/receivableAccounts/accountStatistics.vue'
import FinanceStabilizationFund from './pages/finance/stabilizationFund/table.vue'
import FinanceStabilizationFundList from './pages/finance/stabilizationFund/list.vue'
import FinanceCommissionRecord from './pages/finance/stabilizationFund/commissionRecord.vue'
import FinanceExtractRecord from './pages/finance/stabilizationFund/extractRecord.vue'
import FinanceFixedFee from './pages/finance/fixedFee/table.vue'
import FinanceDrivingFee from './pages/finance/drivingFee/table.vue'
import FinanceOilFee from './pages/finance/oilFee/table.vue'
import FinanceOilFeeList from './pages/finance/oilFee/list.vue'

import FinanceFixedFeeList from './pages/finance/fixedFeeList/table.vue'
import FinanceBaseSalary from './pages/finance/baseSalary/table.vue'
// import FinanceEstimatedProfit from './pages/finance/estimatedProfit/table.vue'
import FinanceEstimatedProfitList from './pages/finance/estimatedProfit/list.vue'
import FinancemonthOrder from './pages/finance/estimatedProfit/monthOrder.vue'
import FinanceMonthFixRecord from './pages/finance/estimatedProfit/monthFixRecord.vue'
import FinanceCaptainSalary from './pages/finance/captainSalary/table.vue'
import FinancemonthOrderFleet from './pages/finance/captainSalary/monthOrder.vue'
import FinanceMonthFixRecordFleet from './pages/finance/captainSalary/monthFixRecord.vue'
import FinanceExpenseSummary from './pages/finance/expenseSummary/table.vue'
import FinanceExpenseSummaryTableDetails from './pages/finance/expenseSummary/tableDetails.vue'

import FinanceMonthlyStatistical from './pages/finance/monthlyStatistical/table.vue'
import FinanceMonthlyAnalysis from './pages/finance/monthlyAnalysis/table.vue'
import FinanceFleetSummary from './pages/finance/fleetSummary/table.vue'
import FinanceFleetAbnormal from './pages/finance/fleetAbnormal/table.vue'
// 公司利润表
import FinanceCompanyProfit from './pages/finance/companyProfit/table.vue'
import FinanceCompanyProfitFleet from './pages/finance/companyProfit/tableFleet.vue'
import FinanceCompanyProfitSingleCar from './pages/finance/companyProfit/tableSingleCar.vue'
import FinanceCompanyProfitOrder from './pages/finance/companyProfit/tableOrder.vue'

// 系统配置
import SystemPersonal from './pages/system/personal/table.vue'
import SystemLoginLog from './pages/system/loginLog/table.vue'
import VehicleFreightIndex from './pages/system/vehicleFreightIndex/table.vue'
import StationConfig from './pages/system/stationConfig/table.vue'
import CargoConfig from './pages/system/cargoConfig/table.vue'
import WarningConfig from './pages/system/warningConfig/table.vue'
import DocumentConfig from './pages/system/documentConfig/table.vue'
import InsuranceConfig from './pages/system/insuranceConfig/table.vue'
import YzkConfig from './pages/system/yzkConfig/table.vue'
import Others from './pages/system/others/table.vue'
import OperationLog from './pages/system/operationLog/table.vue'
import OperationDetail from './pages/system/operationLog/detail.vue'
import MaintainOrgConfig from './pages/system/maintainOrgConfig/table.vue'

import OilFuelSales from './pages/oilStation/fuelSales/table.vue'
import OilFuelSalesDay from './pages/oilStation/fuelSales/day/tabpage.vue'
import OilFuelSalesDayTable from './pages/oilStation/fuelSales/day/table.vue'
import OilFuelSalesOneCar from './pages/oilStation/fuelSales/onecar/tabpage.vue'
import OilFuelSalesOneCarTable from './pages/oilStation/fuelSales/onecar/table.vue'
import OilFuelSalesList from './pages/oilStation/fuelSales/list.vue'
import OilStock from './pages/oilStation/stock/table.vue'
import OilStockList from './pages/oilStation/stock/list.vue'

import MatterReview from './pages/matterReview/table.vue'
import MatterReviewUnCheck from './pages/matterReview/uncheck.vue'
import MatterReviewChecked from './pages/matterReview/checked.vue'
import MatterReviewDetail from './pages/matterReview/detail.vue'
// 帮助中心
import HelpLog from './pages/help/log/list.vue'
// import HelpImprove from './pages/help/improve/list.vue'

const routes = [
  { path: '*', redirect: '/admin' },
  { path: '/login', component: Login },
  {
    path: '/admin',
    component: Home,
    redirect: '/admin/index',
    children: [
      { path: 'index', component: Index },
      //{ path: 'carposition', component: CarPosition },
      { path: 'dataCenter', component: DataCenter },
      { path: 'financialAnalysis', component: FinancialAnalysis },
    ],
  },
  // 事项审核
  {
    path: '/matterReview',
    component: Home,
    redirect: '/matterReview/list',
    children: [
      {
        path: 'list',
        component: MatterReview,
        redirect: 'list/uncheck',
        children: [
          { path: 'uncheck', component: MatterReviewUnCheck },
          { path: 'checked', component: MatterReviewChecked },
        ],
      },
      { path: 'detail', component: MatterReviewDetail },
    ],
  },
  // 订单管理
  {
    path: '/order',
    component: Home,
    redirect: '/order/nocontract',
    children: [
      {
        path: 'contract',
        component: ContractOrder,
        redirect: 'contract/own',
        children: [
          {
            path: 'own',
            component: ContractOrderOwn,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: ContractOrderOwnTobe },
              { path: 'ing', component: ContractOrderOwnIng },
              { path: 'arrive', component: ContractOrderOwnArrive },
              { path: 'uncheck', component: ContractOrderOwnUncheck },
              { path: 'done', component: ContractOrderOwnDone },
            ],
          },
          { path: 'hire', component: ContractOrderHire },
        ],
      },
      { path: 'contractdetail', component: NonContractOrderDetail },
      { path: 'contractview', component: OrderContractView },
      { path: 'contractview1', component: OrderContractView1 },
      { path: 'contractview2', component: OrderContractView2 },
      { path: 'contractview21', component: OrderContractView21 },
      { path: 'contractview3', component: OrderContractView3 },
      { path: 'contractview4', component: OrderContractView4 },
      { path: 'contractview41', component: OrderContractView41 },
      { path: 'contractview5', component: OrderContractView5 },
      { path: 'contractfee', component: OrderNoContractFee },
      {
        path: 'nocontract',
        component: NonContractOrder,
        redirect: 'nocontract/own',
        children: [
          {
            path: 'own',
            component: NonContractOrderOwn,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: NonContractOrderOwnTobe },
              { path: 'ing', component: NonContractOrderOwnIng },
              { path: 'arrive', component: NonContractOrderOwnArrive },
              { path: 'uncheck', component: NonContractOrderOwnUncheck },
              { path: 'done', component: NonContractOrderOwnDone },
            ],
          },
          { path: 'hire', component: NonContractOrderhire },
        ],
      },
      { path: 'nocontractdetail', component: NonContractOrderDetail },
      { path: 'nocontractdetaildone', component: NonContractOrderDetailDone },
      { path: 'nocontractadd', component: OrderNoContractAdd },
      { path: 'nocontractview', component: OrderNoContractView },
      { path: 'nocontractview1', component: OrderNoContractView1 },
      { path: 'nocontractview2', component: OrderNoContractView2 },
      { path: 'nocontractview21', component: OrderNoContractView21 },
      { path: 'nocontractview3', component: OrderNoContractView3 },
      { path: 'nocontractview4', component: OrderNoContractView4 },
      { path: 'nocontractview41', component: OrderNoContractView41 },
      { path: 'nocontractview5', component: OrderNoContractView5 },
      { path: 'nocontractfee', component: OrderNoContractFee },
      { path: 'makeup', component: MakeupList },
      { path: 'makeupdetail', component: Makeupdetail },
      { path: 'makeupedit', component: Makeupedit },
      { path: 'recycle', component: recycle },
      { path: 'recycleview', component: OrderNoContractView1 },
      { path: 'recyclefee', component: OrderNoContractFee },
    ],
  },
  // 合同管理
  {
    path: '/contract',
    component: Home,
    redirect: '/contract/list',
    children: [
      {
        path: 'list',
        component: ContractList,
        redirect: 'list/tobe',
        children: [
          { path: 'tobe', component: ContractTobeList },
          { path: 'ing', component: ContractIngList },
          { path: 'uncheck', component: ContractUncheckList },
          { path: 'done', component: ContractDoneList },
        ],
      },
      // 合同管理-数据统计
      { path: 'statistics', component: AccountStatistics },
      { path: 'detail', component: ContractDetail },
      {
        path: 'orderlist',
        component: ContractOrderList,
        redirect: 'orderlist/own',
        children: [
          {
            path: 'own',
            component: ContractOrderOwnList,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: ContractOrderOwnTobeList },
              { path: 'ing', component: ContractOrderOwnIngList },
              { path: 'arrive', component: ContractOrderOwnArriveList },
              { path: 'uncheck', component: ContractOrderOwnUnckeckList },
              { path: 'done', component: ContractOrderOwnDoneList },
            ],
          },
          { path: 'hire', component: ContractOrderHireList },
          { path: 'all', component: ContractOrderAllList },
        ],
      },
      { path: 'orderview', component: ContractOrderView },
      { path: 'orderDetail', component: ContractOrderDetail },
      { path: 'orderDetail2', component: ContractOrderDetail2 },
      { path: 'orderFeeDetail', component: OrderNoContractFee },
      { path: 'makeup', component: ContractMakeup },
      { path: 'makeupdetail', component: ContractMakeupDetail },
      { path: 'makeupedit', component: ContractMakeupEdit },
    ],
  },
  // 客户管理
  {
    path: '/customer',
    component: Home,
    redirect: '/customer/manage',
    children: [
      {
        path: 'manage',
        component: CustomerList,
      },
      { path: 'detail', component: CustomerDetail },
      { path: 'edit', component: CustomerEdit },
      { path: 'view', component: CustomerView },
      { path: 'carrier', component: CustomerCarrier },
      { path: 'carrierdetail', component: CustomerCarrierDetail },
      {
        path: 'log',
        component: CustomerLog,
        redirect: 'log/table',
        children: [
          {
            path: 'table',
            component: CustomerLogList,
          },
        ],
      },
    ],
  },
  // 车辆管理
  {
    path: '/vehicle',
    component: Home,
    redirect: '/vehicle/manage',
    children: [
      {
        path: 'manage',
        component: Vehicle,
        redirect: 'manage/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1/list/1',
            component: VehicleTeam,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: VehicleList,
              },
              {
                path: 'list/:status',
                component: VehicleList,
              },
            ],
          },
          {
            path: 'table/:idx',
            redirect: 'table/1/list',
            component: VehicleTeam,
            props: true,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: VehicleList,
              },
              {
                path: 'list/:status',
                component: VehicleList,
              },
            ],
          },
        ],
      },
      { path: 'detail', component: VehicleDetail },
      { path: 'document', component: Vehicledocument },
      { path: 'insurance', component: Vehicleinsurance },
      { path: 'document1', component: Vehicledocument },
      { path: 'insurance1', component: Vehicleinsurance },
      { path: 'document2', component: Vehicledocument },
      { path: 'insurance2', component: Vehicleinsurance },
      { path: 'viewTrip', component: VehicleViewTrip },
      { path: 'view', component: VehicleView },
      { path: 'viewurl', component: VehicleViewUrl },
      { path: 'maintain', component: VehicleMaintain },
      { path: 'maintainDetail', component: VehicleMaintainDetail },
      { path: 'group', component: VehicleGroup },
      {
        path: 'groupList',
        component: VehicleGroupList,
        redirect: 'groupList/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: VehicleGroupTable,
          },
          {
            path: 'table/:idx',
            component: VehicleGroupTable,
          },
        ],
      },
      { path: 'expatriate', component: VehicleExpatriate },
      { path: 'expatriatedetail', component: VehicleExpatriateDetail },
      { path: 'expatriateview', component: VehicleExpatriateView },
      {
        path: 'hang',
        component: VehicleHangTab,
        redirect: 'hang/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: VehicleHang,
          },
          {
            path: 'table/:status',
            component: VehicleHang,
          },
        ],
      },
      { path: 'hangdetail', component: VehicleHangDetail },
      { path: 'hangview', component: VehicleHangView },
      // 违章管理
      {
        path: 'breakRules',
        component: BreakRules,
        redirect: 'breakRules/list',
        children: [
          { path: 'list', component: BreakRulesList },
          { path: 'detailList', component: BreakRulesDetailList },
        ],
      },
      // 临期查询
      {
        path: 'documents',
        component: VehicleDocuments,
        redirect: 'documents/list',
        children: [
          { path: 'list', component: VehicleDocumentsList },
          { path: 'insurancelist', component: VehicleInsuranceList },
        ],
      },
      // 隐患排查
      {
        path: 'investDanger',
        component: VehicleInvestDanger,
        redirect: 'investDanger/list',
        children: [
          { path: 'list', component: VehicleInvestDangerList },
          { path: 'monthList', component: VehicleInvestDangerMonthList },
        ],
      },
      { path: 'pdf', component: VehicleInvestDangerPDF },
    ],
  },
  // 维保管理
  {
    path: '/fix',
    component: Home,
    redirect: '/fix/list',
    children: [
      { path: 'list', component: FixList },
      { path: 'detail', component: FixdDtail },
      { path: 'repairlist', component: FixRepairerList },
      { path: 'repairdetail', component: FixRepairerDetail },
      { path: 'repairer', component: FixRepairer },
      { path: 'payment', component: FixPayment },
      { path: 'config', component: FixConfigTable },
      { path: 'recycle', component: FixRecycleTable },
      { path: 'recycledetail', component: FixdDtail },
    ],
  },
  // 人员管理
  {
    path: '/staff',
    component: Home,
    redirect: '/staff/manager',
    children: [
      {
        path: 'manager',
        component: StaffManager,
        redirect: 'manager/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffManagerTable,
          },
          {
            path: 'table/:iswork',
            component: StaffManagerTable,
          },
        ],
      },
      { path: 'managerDetail', component: StaffManagerDetail },
      {
        path: 'mainAccountant',
        component: StaffMainAccountant,
        redirect: 'mainAccountant/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffMainAccountantTable,
          },
          {
            path: 'table/:iswork',
            component: StaffMainAccountantTable,
          },
        ],
      },
      { path: 'mainAccountantDetail', component: MainAccountantDetail },
      {
        path: 'specialAccountant',
        component: StaffSpecialAccountant,
        redirect: 'specialAccountant/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffSpecialAccountantTable,
          },
          {
            path: 'table/:iswork',
            component: StaffSpecialAccountantTable,
          },
        ],
      },
      { path: 'specialAccountantDetail', component: SpecialAccountantDetail },
      {
        path: 'cashier',
        component: StaffCashier,
        redirect: 'cashier/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffCashierTable,
          },
          {
            path: 'table/:iswork',
            component: StaffCashierTable,
          },
        ],
      },
      { path: 'cashierDetail', component: CashierDetail },
      {
        path: 'captain',
        component: StaffCaptain,
        redirect: 'captain/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffCaptainTable,
          },
          {
            path: 'table/:iswork',
            component: StaffCaptainTable,
          },
        ],
      },
      { path: 'captainDetail', component: StaffCaptainDetail },
      {
        path: 'salesman',
        component: StaffSalesman,
        redirect: 'salesman/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffSalesmanTable,
          },
          {
            path: 'table/:iswork',
            component: StaffSalesmanTable,
          },
        ],
      },
      { path: 'salesmanDetail', component: StaffSalesmanDetail },
      {
        path: 'viceCaptain',
        component: StaffViceCaptain,
        redirect: 'viceCaptain/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffViceCaptainTable,
          },
          {
            path: 'table/:iswork',
            component: StaffViceCaptainTable,
          },
        ],
      },
      { path: 'viceCaptainDetail', component: ViceCaptainDetail },
      {
        path: 'maintenance',
        component: StaffMaintenance,
        redirect: 'maintenance/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffMaintenanceTable,
          },
          {
            path: 'table/:iswork',
            component: StaffMaintenanceTable,
          },
        ],
      },
      { path: 'maintenanceDetail', component: Maintenancedetail },
      {
        path: 'vehicleService',
        component: StaffVehicleService,
        redirect: 'vehicleService/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: StaffVehicleServiceTable,
          },
          {
            path: 'table/:iswork',
            component: StaffVehicleServiceTable,
          },
        ],
      },
      { path: 'vehicleServiceDetail', component: VehicleServiceDetail },
      {
        path: 'driver',
        component: StaffDriver,
        redirect: 'driver/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1/list/1',
            component: StaffDriverTeam,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffDriverList,
              },
              {
                path: 'list/:iswork',
                component: StaffDriverList,
              },
            ],
          },
          {
            path: 'table/:idx',
            redirect: 'table/1/list',
            component: StaffDriverTeam,
            props: true,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffDriverList,
              },
              {
                path: 'list/:iswork',
                component: StaffDriverList,
              },
            ],
          },
        ],
      },
      { path: 'driverDetail', component: StaffDriverDetail },
      { path: 'driverHy', component: StaffDriverHy },
      { path: 'driverDocument', component: StaffDriverDocument },
      { path: 'escortDocument', component: StaffDriverDocument },
      { path: 'escortHy', component: StaffEscortHy },
      {
        path: 'escort',
        component: StaffEscort,
        redirect: 'escort/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1/list/1',
            component: StaffEscortTeam,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffEscortList,
              },
              {
                path: 'list/:iswork',
                component: StaffEscortList,
              },
            ],
          },
          {
            path: 'table/:idx',
            redirect: 'table/1/list',
            component: StaffEscortTeam,
            props: true,
            children: [
              {
                path: 'list',
                redirect: 'list/1',
                component: StaffEscortList,
              },
              {
                path: 'list/:iswork',
                component: StaffEscortList,
              },
            ],
          },
        ],
      },
      { path: 'escortDetail', component: StaffEscortDetail },
      { path: 'tempDriver', component: StaffTempDriver },
      { path: 'tempDriverDetail', component: TempDriverDetail },
      { path: 'tempEscort', component: StaffTempEscort },
      { path: 'tempEscortDetail', component: TempEscortDetail },
      { path: 'staffcont', component: StaffCont },
    ],
  },
  // 考勤管理
  {
    path: '/attendance',
    component: Home,
    redirect: '/attendance/vehicleAttendance',
    children: [
      { path: 'vehicleAttendance', component: StaffVehicleAttendance },
      { path: 'attendanceSummary', component: StaffAttendanceSummary },
      { path: 'driverAttendance', component: StaffDriverAttendance },
      { path: 'escortAttendance', component: StaffEscortAttendance },
    ],
  },
  // 财务管理
  {
    path: '/finance',
    component: Home,
    redirect: '/finance/list',
    children: [
      {
        path: 'reimburse',
        component: FinanceReimburse,
        redirect: 'reimburse/table',
        children: [
          {
            path: 'table',
            component: FinanceReimburseTable,
          },
          {
            path: 'tableChecked',
            component: FinanceReimburseTableChecked,
          },
        ],
      },
      { path: 'feightStatistics', component: FinanceFeightStatistics },
      { path: 'shipper', component: FinanceShipper },
      { path: 'viewOrder', component: ViewOrder },
      { path: 'contractFix', component: ContractFix },
      { path: 'paymentHistory', component: PaymentHistory },
      { path: 'initialPayment', component: FinanceInitialPayment },
      { path: 'initialPaymentRecord', component: InitialPaymentRecord },
      { path: 'moneyDetail', component: InitialPaymentRecordMoneyDetail },
      { path: 'allmoneyDetail', component: InitialPaymentRecordAllMoneyDetail },
      { path: 'initialAllPaymentRecord', component: InitialAllPaymentRecord },
      { path: 'carrier', component: FinanceCarrier },
      { path: 'carrierOrder', component: CarrierOrder },
      { path: 'carrierPaymentHistory', component: CarrierPaymentHistory },
      { path: 'receivableAccounts', component: FinanceReceivableAccounts },
      { path: 'statistics', component: AccountStatistics },
      {
        path: 'stabilizationFund',
        component: FinanceStabilizationFund,
        redirect: 'stabilizationFund/table',
        children: [
          {
            path: 'table',
            component: FinanceStabilizationFundList,
          },
          {
            path: 'table/:iswork',
            component: FinanceStabilizationFundList,
          },
        ],
      },
      { path: 'commissionRecord', component: FinanceCommissionRecord },
      { path: 'extractRecord', component: FinanceExtractRecord },
      { path: 'fixedFee', component: FinanceFixedFee },
      { path: 'drivingFee', component: FinanceDrivingFee },
      {
        path: 'oilFee',
        component: FinanceOilFee,
        redirect: 'oilFee/table',
        children: [
          {
            path: 'table',
            redirect: 'table/1',
            component: FinanceOilFeeList,
          },
          {
            path: 'table/:idx',
            component: FinanceOilFeeList,
          },
        ],
      },
      // 油气费汇总表详情
      { path: 'oilfeedetails', component: OrderNoContractFee },
      { path: 'fixedFeeList', component: FinanceFixedFeeList },
      { path: 'baseSalary', component: FinanceBaseSalary },
      {
        path: 'estimatedProfit',
        component: FinanceEstimatedProfitList,
        // redirect: 'estimatedProfit/table',
        // children: [
        //   {
        //     path: 'table',
        //     redirect: 'table/1',
        //     component: FinanceEstimatedProfitList,
        //   },
        //   {
        //     path: 'table/:idx',
        //     component: FinanceEstimatedProfitList,
        //   },
        // ],
      },
      { path: 'companyProfit', component: FinanceCompanyProfit },
      { path: 'companyProfitFleet', component: FinanceCompanyProfitFleet },
      { path: 'companyProfitSingleCar', component: FinanceCompanyProfitSingleCar },
      { path: 'companyProfitOrder', component: FinanceCompanyProfitOrder },
      { path: 'monthorder', component: FinancemonthOrder },
      { path: 'monthfixrecord', component: FinanceMonthFixRecord },
      { path: 'captainSalary', component: FinanceCaptainSalary },
      { path: 'monthorderfleet', component: FinancemonthOrderFleet },
      { path: 'monthfixrecordfleet', component: FinanceMonthFixRecordFleet },
      { path: 'expenseSummary', component: FinanceExpenseSummary },
      { path: 'tabledetails', component: FinanceExpenseSummaryTableDetails },
      // 出车费用汇总表详情
      { path: 'feedetails', component: OrderNoContractFee },
      { path: 'monthlyStatistical', component: FinanceMonthlyStatistical },
      { path: 'monthlyAnalysis', component: FinanceMonthlyAnalysis },
      { path: 'financeFleetSummary', component: FinanceFleetSummary },
      { path: 'financeFleetAbnormal', component: FinanceFleetAbnormal },
    ],
  },
  // 加油站管理
  {
    path: '/oilStation',
    component: Home,
    redirect: '/oilStation/fuelSales',
    children: [
      {
        path: 'fuelSales',
        component: OilFuelSales,
        redirect: 'fuelSales/day',
        children: [
          {
            path: 'day',
            component: OilFuelSalesDay,
            redirect: 'day/table',
            children: [
              { path: 'table', component: OilFuelSalesDayTable },
            ],
          },
          {
            path: 'onecar',
            component: OilFuelSalesOneCar,
            redirect: 'onecar/table',
            children: [
              { path: 'table', component: OilFuelSalesOneCarTable },
            ],
          },
        ],
      },
      { path: 'fuelSalesList', component: OilFuelSalesList },
      {
        path: 'stock',
        component: OilStock,
        redirect: 'stock/table',
        children: [
          {
            path: 'table',
            component: OilStockList,
          },
        ],
      },
    ],
  },
  // 系统设置
  {
    path: '/system',
    component: Home,
    redirect: '/system/personal',
    children: [
      { path: 'personal', component: SystemPersonal },
      { path: 'loginLog', component: SystemLoginLog },
      { path: 'vehicleFreightIndex', component: VehicleFreightIndex },
      { path: 'stationConfig', component: StationConfig },
      { path: 'cargoConfig', component: CargoConfig },
      { path: 'warningConfig', component: WarningConfig },
      { path: 'documentConfig', component: DocumentConfig },
      { path: 'insuranceConfig', component: InsuranceConfig },
      { path: 'yzkConfig', component: YzkConfig },
      { path: 'others', component: Others },
      { path: 'operationLog', component: OperationLog },
      { path: 'operationDetail', component: OperationDetail },
      { path: 'maintainOrgConfig', component: MaintainOrgConfig },
    ],
  },
  // 帮助中心
  {
    path: '/help',
    component: Home,
    redirect: '/help/operation',
    children: [
      { path: 'log', component: HelpLog },
      // { path: 'improve', component: HelpImprove },
    ],
  },
]

const ROUTE = {
  mode: 'history',
  base: publicPath,
  routes,
}

export default ROUTE